






















































































































































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import {State} from "vuex-class";
import {PolisaOsiguranja, Vozilo} from "@/services/BackendProxies";
import dataProxy from '@/services/data-proxy.service';
import {TabsPlugin} from "bootstrap-vue";
import {TabBase} from "@/views/Vozila/PodaciVozila/TabBase";

const KASKO = 'KaskoOsiguranje';
const OSIGURANJE_OD_ODGOVORNOSTI = 'OsiguranjaOdOdgovornosti';

@Component({})
export default class Tab4 extends TabBase {
    @State vozilo!: Vozilo;
    kaskoPolise = [PolisaOsiguranja.fromJS({vrsta: KASKO})];
    poliseOsiguranjaOdOdgovornosti = [PolisaOsiguranja.fromJS({vrsta: OSIGURANJE_OD_ODGOVORNOSTI})];

    kasko: PolisaOsiguranja = PolisaOsiguranja.fromJS({vrsta: KASKO});
    osiguranjeOdOdgovornosti: PolisaOsiguranja = PolisaOsiguranja.fromJS({vrsta: OSIGURANJE_OD_ODGOVORNOSTI});

    @Watch('vozilo') async onVoziloChanged(vozilo) {
        if (vozilo.id) {
            const polise = await dataProxy.vratiPoliseVozila(vozilo.id);
            this.razdvojPolise(polise);
        }
    }

    async kreirajNovuKaskoPolisu() {
        const lastValid = await (<any>this.$refs.kaskoForm).validate();
        if (lastValid) {
            return PolisaOsiguranja.fromJS({vrsta: KASKO});
        }
    }

    async kreirajNovuPolisuOsiguranjaOdOdgovornosti() {
        const lastValid = await (<any>this.$refs.osiguranjeOsOdgovornostiForm).validate();
        if (lastValid) {
            return PolisaOsiguranja.fromJS({vrsta: OSIGURANJE_OD_ODGOVORNOSTI});
        }
    }

    async handleRemoved(polisa: PolisaOsiguranja) {
        if (polisa.id) {
            await this.saveData(() => dataProxy.obrisiPolisu(this.vozilo.id, polisa.id))();
        }
    }

    async handleSave() {
        const polise = await this.saveData(() => dataProxy.sacuvajPolise(this.vozilo.id,
            [...this.poliseOsiguranjaOdOdgovornosti, ...this.kaskoPolise]))();
        this.razdvojPolise(polise);
    }

    osiguravajuceKuce = async (params, success, failure) => {
        const osiguravajuceKuce = await dataProxy.vratiOsiguravajuceKuce(params.data.term);
        success(osiguravajuceKuce);
    };

    private razdvojPolise(polise: PolisaOsiguranja[]) {
        const kaskoPolise = polise.filter(x => x.vrsta == KASKO);
        const poliseOsiguranjaOdOdgovornosti = polise.filter(x => x.vrsta == OSIGURANJE_OD_ODGOVORNOSTI);
        if (kaskoPolise.length === 0) {
            kaskoPolise.push(PolisaOsiguranja.fromJS({vrsta: KASKO}));
        }
        if (poliseOsiguranjaOdOdgovornosti.length === 0) {
            poliseOsiguranjaOdOdgovornosti.push(PolisaOsiguranja.fromJS({vrsta: OSIGURANJE_OD_ODGOVORNOSTI}));
        }
        this.kaskoPolise = kaskoPolise;
        this.poliseOsiguranjaOdOdgovornosti = poliseOsiguranjaOdOdgovornosti;
    }

}
